import { render, staticRenderFns } from "./HizmetDuzenle.vue?vue&type=template&id=5347219e&scoped=true&"
import script from "./HizmetDuzenle.vue?vue&type=script&lang=js&"
export * from "./HizmetDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./HizmetDuzenle.vue?vue&type=style&index=0&id=5347219e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5347219e",
  null
  
)

export default component.exports